import React, { useContext, useEffect, useRef } from 'react';
import { Switch, Route, Redirect, generatePath } from 'react-router-dom';
import { useIntl } from 'react-intl';
import useBackNavigation from 'hooks/utils/useBackNavigation';

import {
  ROUTE_USER_ENTITY_DOCUMENTS,
  ROUTE_USER_ENTITY_PROGRAMS_PROGRAM,
  ROUTE_USER_ENTITY_PROGRAMS,
  ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_FEEDBACK,
  ROUTE_USER_PROGRAMS,
  ROUTE_USER_REPORTS_ENTITY,
  ROUTE_USER_REPORTS_ENTITY_REPORT,
  ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT,
  ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA,
  ROUTE_USER_DOCUMENTS,
  ROUTE_USER_REPORTS,
  ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE
} from 'routes/RouteList';

import { StoreContext } from 'index';
import usePostMessage from 'hooks/utils/usePostMessage';
import messages from 'messages';
import Panel from 'components/panel/Panel';
import Documents from 'containers/pages/mobile/documents/Documents';
import OverviewPrograms from './programs/Overview';
import Program from 'containers/pages/mobile/programs/Program';
import ProgramExercise from 'containers/pages/mobile/programs/ProgramExercise';
import OverviewReports from './reports/Overview';
import Report from './reports/Report';

import { SessionContextProvider } from 'contexts/SessionContext';
import {
  createEntityStore,
  EntityStoreProvider
} from 'containers/pages/persons/store/EntityStoreContext';
import { TestDataProvider } from 'contexts/TestDataContext';

const Index = () => {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const intl = useIntl();
  const { message } = usePostMessage();
  const entityStore = useRef(createEntityStore()).current;
  const { removeHelperVariables } = usePostMessage();
  useEffect(() => {
    if (message) {
      console.log('message', message);
    }
  }, [message]);

  useBackNavigation();
  removeHelperVariables();
  return (
    <Switch>
      {/* --- REPORTS --- */}
      <Route
        path={[
          ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA,
          ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT,
          ROUTE_USER_REPORTS_ENTITY_REPORT,
          ROUTE_USER_REPORTS_ENTITY
        ]}
      >
        <OverviewReports />
        <Switch>
          <Route
            exact
            path={[
              ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA,
              ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT,
              ROUTE_USER_REPORTS_ENTITY_REPORT
            ]}
          >
            <SessionContextProvider>
              <EntityStoreProvider value={entityStore}>
                <TestDataProvider>
                  <Report />
                </TestDataProvider>
              </EntityStoreProvider>
            </SessionContextProvider>
          </Route>
          <Route exact path={ROUTE_USER_REPORTS_ENTITY}>
            <Panel
              emptyState
              emptyLabel={intl.formatMessage(messages.sessionsEmptyPanel)}
            />
          </Route>
        </Switch>
      </Route>

      <Redirect
        exact
        from={ROUTE_USER_REPORTS}
        to={generatePath(ROUTE_USER_REPORTS_ENTITY, {
          entityId: user.rootEntityId
        })}
      />

      {/* --- PROGRAMS --- */}
      <Route path={[ROUTE_USER_ENTITY_PROGRAMS]}>
        <Route
          path={[
            ROUTE_USER_ENTITY_PROGRAMS_PROGRAM,
            ROUTE_USER_ENTITY_PROGRAMS
          ]}
        >
          <OverviewPrograms />
        </Route>
        <Switch>
          <Route
            path={[
              ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE,
              ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_FEEDBACK,
              ROUTE_USER_ENTITY_PROGRAMS_PROGRAM
            ]}
          >
            <Program />
            <Switch>
              <Route path={ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE}>
                <ProgramExercise />
              </Route>
            </Switch>
          </Route>

          <Route exact path={ROUTE_USER_ENTITY_PROGRAMS}>
            <Panel
              emptyState
              emptyLabel={intl.formatMessage(messages.exercisesEmptyPanel)}
            />
          </Route>
        </Switch>
      </Route>

      <Redirect
        exact
        from={ROUTE_USER_PROGRAMS}
        to={generatePath(ROUTE_USER_ENTITY_PROGRAMS, {
          entityId: user.rootEntityId
        })}
      />

      {/* --- DOCUMENTS --- */}
      <Route exact path={ROUTE_USER_ENTITY_DOCUMENTS}>
        <Documents />
        <Panel
          emptyState
          emptyLabel={intl.formatMessage(messages.documentsEmptyPanel)}
        />
      </Route>

      <Redirect
        exact
        from={ROUTE_USER_DOCUMENTS}
        to={generatePath(ROUTE_USER_ENTITY_DOCUMENTS, {
          entityId: user.rootEntityId
        })}
      />

      <Redirect to={ROUTE_USER_REPORTS} />
    </Switch>
  );
};

export default Index;
